export default __webpack_public_path__ + "static/media/3.244e45b8.svg";